import calenderIcon from "../../assets/img/calenderIcon.svg"; 
import csvIcon from "../../assets/img/csvicon.svg";           
import DownloadIcon from "../../assets/icon/Download.svg"; 
import pdfIcon from "../../assets/img/pdficon.svg";          
import xlsIcon from "../../assets/img/xlsicon.svg";          
import { useTranslation } from "react-i18next";
import { FaArrowLeft } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import useAbacAccess from "../../hooks/useAbacAccess";
import { resolveAbacPathsForLocation } from "../User/Abac/abacRouteMap";
import AppBreadcrumb from "./AppBreadcrumb";
import CustomSelect from "./CustomSelect";

const CommonHeader = ({
  name,
  breadcrumb,
  fileType,
  handleFileTypeChange,
  downloadContent,
  /** Explicit ABAC path for download; else derived from route + "download". */
  abacPath,
  /** When set, overrides route-map download gating (wallet uses common.wallet). */
  downloadAllowed,
  filterData,
  discardedFileType,
  customChildren,
  children,
  timeSeperator,
  onBack,
}) => {
  const { t } = useTranslation("common");
  const location = useLocation();
  const { canAccessView, shouldEnforce } = useAbacAccess();
  const resolvedDownloadPath = (() => {
    if (abacPath) return abacPath;
    const mapped = resolveAbacPathsForLocation(location.pathname);
    if (!mapped?.length || !Array.isArray(mapped[0])) return null;
    return [...mapped[0], "download"];
  })();
  const canDownload =
    typeof downloadAllowed === "boolean"
      ? downloadAllowed
      : shouldEnforce
        ? Boolean(resolvedDownloadPath) && canAccessView(resolvedDownloadPath)
        : true;
  let downloadTypes = [
    { value: "csv", label: "CSV", image: csvIcon },
    { value: "pdf", label: "PDF", image: pdfIcon },
    { value: "xlsx", label: "XLSX", image: xlsIcon },
  ].filter((k) => discardedFileType?.[k.value] === undefined);

  let keepDownload =
    canDownload &&
    fileType &&
    handleFileTypeChange &&
    downloadContent &&
    downloadTypes;

  let childLength =
    typeof children === "undefined"
      ? 1
      : typeof children === "object"
      ? 2
      : children.length + 1;

  return (
  <div className="mb-3">
    {breadcrumb?.items?.length > 0 && (
      <AppBreadcrumb
        items={breadcrumb.items}
        showBackButton={breadcrumb.showBackButton}
        backTo={breadcrumb.backTo}
        className={breadcrumb.className}
      />
    )}
    <div className="commonHeader">
      {onBack && (
        <button
          type="button"
          className="btn dwn-btn-border bg-white"
          onClick={onBack}
          title={t("back", { defaultValue: "Back" })}
        >
          <FaArrowLeft />
          <span className="d-none d-sm-inline">
            {t("back", { defaultValue: "Back" })}
          </span>
        </button>
      )}
      <p>{name}</p>
      <div
        className="d-flex gap-2 align-items-center common-header-actions"
        style={{
          "--dropdownWidth": Math.ceil(100 / childLength) - 2 + "%",
        }}
      >
        {children && children}

        {filterData && filterData.startDate && filterData.endDate && (
          <div className="filteredDate d-flex gap-1 dwn-btn-border align-items-center bg-white">
            <img
              src={calenderIcon}
              loading="lazy"
              className="d-none d-sm-block"
            />
            <p className="mb-0 fw-500 d-none d-md-block fs-14">
              {t("dateLabel", { defaultValue: "Date:" })}
            </p>
            <p className="mb-0 text-gray px-1 px-md-2 fs-14">
              {
                filterData.startDate
                  .split(timeSeperator ?? " ")[0]
                  .split("-")
                  .reverse()
                  .join("-") +
                  (!timeSeperator
                    ? ""
                    : " " + filterData.startDate.split(timeSeperator)[1])
              }
            </p>
            <p className="mb-0 fw-500 d-none d-md-block fs-14">
              {t("toLabel", { defaultValue: "to" })}
            </p>
            <p className="mb-0 fw-500 d-block d-md-none fs-14">-</p>
            <p className="mb-0 text-gray ps-1 ps-md-2 fs-14">
              {
                filterData.endDate
                  .split(timeSeperator ?? " ")[0]
                  .split("-")
                  .reverse()
                  .join("-") +
                  (!timeSeperator
                    ? ""
                    : " " + filterData.endDate.split(timeSeperator)[1])
              }
            </p>
          </div>
        )}

        {keepDownload && (
          <div className="dropdown download-dropdown">
            <div className="d-flex dwn-btn-border align-items-center bg-white">
              <div
                className="custom-select-wrapper"
                style={{
                  position: "relative",
                  zIndex: 5,
                  borderRight: "1px solid #b5b5b5",
                  minWidth: 55,
                  flexShrink: 0,
                }}
              >
                <CustomSelect
                  selectData={{
                    fileType,
                    handleFileTypeChange,
                    downloadTypes,
                  }}
                />
              </div>
              <button
                type="button"
                className="btn dwn-btn"
                onClick={downloadContent}
              >
                <span>{t("download", { defaultValue: "Download" })}</span>
                <img
                  src={DownloadIcon}
                  alt=""
                  loading="lazy"
                  className="ms-2"
                />
              </button>
            </div>
          </div>
        )}

        {customChildren && customChildren}
      </div>
    </div>
  </div>
  );
};

export default CommonHeader;
